import { useEffect, useRef, useState } from 'react'

/**
 * Returns a ref to attach to the sentinel element and a boolean indicating
 * whether it is currently intersecting the viewport.
 * Use this to trigger infinite scroll / lazy loading.
 */
export function useIntersection(options?: IntersectionObserverInit): {
  ref: React.RefObject<HTMLDivElement | null>
  isIntersecting: boolean
} {
  const ref = useRef<HTMLDivElement>(null)
  const [isIntersecting, setIsIntersecting] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting)
    }, options)

    observer.observe(el)
    return () => observer.disconnect()
  }, [options])

  return { ref, isIntersecting }
}
